module.exports = __webpack_public_path__ + "static/media/W.8ab441d1.jpg";